/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
    DayOfWeekToJSONTyped,
} from './DayOfWeek';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateAppointmentHourRequest
 */
export interface CreateAppointmentHourRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateAppointmentHourRequest
     */
    teacherId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof CreateAppointmentHourRequest
     */
    day: DayOfWeek;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentHourRequest
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentHourRequest
     */
    endTime: string;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof CreateAppointmentHourRequest
     */
    locationId?: ActorActivityRecordActorUserId | null;
}



/**
 * Check if a given object implements the CreateAppointmentHourRequest interface.
 */
export function instanceOfCreateAppointmentHourRequest(value: object): value is CreateAppointmentHourRequest {
    if (!('teacherId' in value) || value['teacherId'] === undefined) return false;
    if (!('day' in value) || value['day'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function CreateAppointmentHourRequestFromJSON(json: any): CreateAppointmentHourRequest {
    return CreateAppointmentHourRequestFromJSONTyped(json, false);
}

export function CreateAppointmentHourRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAppointmentHourRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'teacherId': ApiUserTasksGetPageParameterFromJSON(json['teacherId']),
        'day': DayOfWeekFromJSON(json['day']),
        'startTime': json['startTime'],
        'endTime': json['endTime'],
        'locationId': json['locationId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['locationId']),
    };
}

export function CreateAppointmentHourRequestToJSON(json: any): CreateAppointmentHourRequest {
    return CreateAppointmentHourRequestToJSONTyped(json, false);
}

export function CreateAppointmentHourRequestToJSONTyped(value?: CreateAppointmentHourRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teacherId': ApiUserTasksGetPageParameterToJSON(value['teacherId']),
        'day': DayOfWeekToJSON(value['day']),
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
    };
}

